

// @ts-nocheck

  /*
  
  Testimonial removed:
  
  
  */


import Vue from "vue";

export default Vue.extend({
    data() {
        return {
            opened: false
        }
    },
    props: {
        index: Object,
        showRating: {
          default: true,
          type: Boolean
        },
        showThankYou: {
            default: false,
            type: Boolean
        },
        showWelcome: {
            default: false,
            type: Boolean
        }
    },
    methods: {
        addComponent(type): void {
            this.opened = false
            this.$emit('addComponent', type, this.index)
        }
    }
});
